import {
  organisationsBySubscription, subscriptionsInDb, plansInDB, invoices
} from './FakeData';

function isOrganisationTiedToSubscription(subscriptionId, organisationId) {
  return organisationsBySubscription.some(mapping => (mapping.subscriptionId === subscriptionId) && mapping.organisationIds.includes(organisationId));
}

function asyncResolveWith(result) {
  return new Promise(resolve => {
    setTimeout(() => resolve(result), 0);
  });
}

export default class FakeSubscriptionService {
  subscriptionExistsByExternalOrganisation() {
    return asyncResolveWith(false);
  }

  findSubscriptionByOrganisation(organisationId) {
    const subscription = subscriptionsInDb.find(subscriptionItem => isOrganisationTiedToSubscription(subscriptionItem.id, organisationId));

    if (subscription) {
      return asyncResolveWith(subscription);
    }

    return asyncResolveWith(null);
  }

  getSuggestedPlans() {
    return asyncResolveWith(plansInDB);
  }

  getOrganisationPlan() {
    return asyncResolveWith(plansInDB[Math.floor(Math.random() * plansInDB.length)]);
  }

  upgradeToPlan() {
    return asyncResolveWith();
  }

  subscribeToPlan() {
    return asyncResolveWith();
  }

  getInvoicesByOrganisation() {
    return asyncResolveWith({
      invoices,
      nextOffset: 'nextOffset'
    });
  }

  getInvoiceUrl() {
    return 'http://www.archeonavale.org/pdf/cordeliere/test.pdf';
  }

  getNumberOfActiveClients(_organisationId) {
    return asyncResolveWith(15);
  }
}
